
/// <reference path="activationsgrid.ts" />

namespace RecordShield.Workspace {

    export interface ProductPickerOptions {
        hideProducts?: number[];
    }
    import fld = ActivationsRow.Fields;
    @Serenity.Decorators.registerClass()
    export class ActivationCheckGrid extends Serenity.EntityGrid<ActivationsRow, ProductPickerOptions> {
       
        private marks;
        private SectionId;
        protected getColumnsKey() { return "Workspace.Activations"; }
        protected getDialogType() { return <any>ActivationsDialog; }
        protected getIdProperty() { return ActivationsRow.idProperty; }
        protected getLocalTextPrefix() { return ActivationsRow.localTextPrefix; }
        protected getService() { return ActivationsService.baseUrl; }
      
        

        constructor(container: JQuery, options: ProductPickerOptions) {
            super(container, options);           
            
            
        }

        
        protected getQuickFilters() {

            var filters = super.getQuickFilters();


            filters.splice(0, 4);


            return filters;

        }

       
        //protected usePager() {
        //    return false;
        //}

        protected getInitialTitle() {
            return null;
        }

        protected getButtons() {
            var buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != 'add-button');
            //buttons[0].onClick:()
            return buttons;
        }

        

        get QuestionMarks() {            
            return  this.marks;
        }

        get ExamSectionId() {
            
            return this.SectionId;
        }
        

        onViewSubmit() {
            if (!super.onViewSubmit())
                return false;

            var request = this.view.params as Serenity.ListRequest;
           
            if (this.options.hideProducts && this.options.hideProducts.length)
                request.Criteria = Serenity.Criteria.and(request.Criteria,
                    [[ActivationsRow.Fields.UserId], 'in', [this.options.hideProducts]]);

            return true;
        }
    }
}